import { useQuery } from '@tanstack/react-query';
import socialProfile from 'models/user/ViewerSocialProfile';

const usePreference = (preferenceKey) => {
    return useQuery({
        queryKey: ['preference', preferenceKey],
        queryFn: () => fetch(`/modern/preference/${preferenceKey}`).then((res) => res.json()),
        staleTime: 60 * 1000
    });
};

export const useUserHasFeature = (preferenceKey) => {
    const { isPending, error, data, isSuccess } = usePreference(preferenceKey);

    return {
        isPending,
        isSuccess,
        error,
        isAvailable: socialProfile.hasRole(data?.value)
    };
};
